
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_57601_4444)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.162 2.934A9.25 9.25 0 115.65 18.727a1 1 0 011.373-1.454 7.25 7.25 0 10-.182-10.37L4.824 8.75H6.75a1 1 0 110 2h-4.5a1 1 0 01-1-1v-4.5a1 1 0 112 0v2.23l2.225-2.037a9.25 9.25 0 014.687-2.509z","fill":"#282E3E"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_57601_4444"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    